import Parameter from '../../Parameter';
import { IParameterProperty } from '../../../../../../types/IParameter';

export interface IRadioParameterProperty extends IParameterProperty {
  checked: boolean;
}

export default class RadioGroup extends Parameter {
  public radioInputs: IRadioParameterProperty[];

  constructor(parameter: IParameterProperty, inputs: IParameterProperty[] | null) {
    super(parameter);

    this.radioInputs = inputs && inputs.length ? this.consolidateRelatedRadioInputs(inputs) : [];
    this._value = this.radioInputs.find(element => element.checked)?.value;
    this._originalValue = this._value;
  }

  private consolidateRelatedRadioInputs(inputs: IParameterProperty[]): IRadioParameterProperty[] {
    return inputs.filter((input) => {
      return input.name === this.name && input.type === this.type && input.fieldSet === this.fieldSet;
    }) as IRadioParameterProperty[];
  }
}
